import{Z as o,d as s}from"./p-DyN-RDr7.js";const r=o;const t=s;export{r as ZprModal,t as defineCustomElement};
//# sourceMappingURL=zpr-modal.js.map